import { taskApi } from 'api';

export const deleteTaskAttachment = async (taskAttachmentId: string, serviceAgreementUid: string) => {
  return await taskApi.deleteTaskAttachment({ serviceAgreementUid, taskUid: taskAttachmentId });
};
